<section id="Services">
    <div class="row">
        <div class="title-section">
            <h3></h3>
        </div>
        <div class="body-section">
            <div class="column medium-4">
                <strong routerLink="">
                    <a target="_blank" routerLink="/home/starting-point">
                        <i>
                            <img with="32px" class="normal style-svg" src="./assets/images/placeholder-black.svg">
                            <img class="hover style-svg" src="./assets/images/placeholder-black.svg"
                                style="fill:#cd2027">
                        </i>
                        نقطه شروع </a>
                </strong>
                <p>مدیریت سرمایه‌گذاری خود را به ما بسپارید.</p>
            </div>
            <div class="column medium-4">
                <strong>
                    <a target="_blank" routerLink="/consulting"
                        [queryParams]="{type:consultingService.FUNDS_MANAGEMENT}">
                        <i>
                            <img with="32px" class="normal style-svg" src="./assets/images/headphones-with-mic.svg">
                            <img class="hover style-svg" src="./assets/images/headphones-with-mic.svg"
                                style="fill:#cd2027">
                        </i>
                        درخواست مشاوره</a>
                </strong>
                <p>مشتاقانه آماده پاسخگویی به سوالات شما در رابطه با خدماتمان هستیم.</p>
            </div>
            <div class="column medium-4">
                <strong>
                    <a routerLink="/portfolio-management/job-opportunities" target="_blank">
                        <i>
                            <img with="32px" class="normal style-svg" src="./assets/images/office-chair.svg">
                            <img class="hover style-svg" src="./assets/images/office-chair.svg" style="fill:#cd2027">
                        </i>
                        فرصت های شغلی </a>
                </strong>
                <p>جهت ارائه خدمات حرفه‌ای و برتر، شما را به همکاری با آبــان دعوت می کنیم.</p>
            </div>
        </div>
    </div>
</section>